export const AnalyticsCookies = {
  cookiesTable: [
    {
      vendor: 'Workable',
      vendorURL: 'https://www.workable.com/privacy',
      cookies:
        'wmc, _swmc, oidc_session_state, jvs_<id>, _session.sig, Lda_<id>, oneDayExecutionLimitLastInjectionXx'
    },
    {
      vendor: 'Google',
      vendorURL: 'https://business.safety.google/privacy/',
      cookies:
        '_ga_<id>, _ga, _gid, _dc_gtm_<id>, _gat, _gac_<id>, _gaexp, _gat_UA-<id>, _gat_<id>, _gcl_gs, _gcl_gb'
    },
    {
      vendor: 'Heap',
      vendorURL: 'https://www.heap.io/privacy',
      cookies: '_hp2_id.<id>, _hp2_ses_props.<id>, _hp2_props.<id>, _hp2_hld.<id>, userty.cor'
    },
    {
      vendor: 'Linkedin',
      vendorURL: 'https://www.linkedin.com/legal/privacy-policy',
      cookies: 'ln_or, lms_analytics, lms_ads, lms_analytics, AnalyticsSyncHistory'
    },
    {
      vendor: 'Hotjar',
      vendorURL: 'https://www.hotjar.com/legal/policies/privacy/',
      cookies:
        '_hjSessionUser_<id>, _hjFirstSeen, _hjIncludedInSessionSample_<id>,_hjSession_<id>, _hjIncludedInPageviewSample, _hjAbsoluteSessionInProgress, _hjid, _hjIncludedInSample, _hjClosedSurveyInvites, _hjDonePolls, _hjMinimizedPolls, _hjDoneTestersWidgets, _hjMinimizedTestersWidgets, _hjShownFeedbackMessage'
    },
    {
      vendor: 'Hubspot',
      vendorURL: 'https://legal.hubspot.com/privacy-policy',
      cookies:
        'hs-messages-hide-welcome-message, hubspotutk, __hssrc, _ttp, _tt_enable_cookie, __hstc, hubspotapi-csrf, IR_PI, hubspotapi-prefs'
    },
    {
      vendor: 'Salesforce',
      vendorURL: 'https://www.salesforce.com/company/legal/privacy/',
      cookies: '8N029N81, visitor_id<id>, visitor_id<id>-hash'
    },
    {
      vendor: 'Microsoft',
      vendorURL: 'https://www.microsoft.com/en-gb/privacy/privacystatement',
      cookies: 'ai_user'
    },
    {
      vendor: 'Pendo',
      vendorURL: 'https://www.pendo.io/legal/privacy-policy/',
      cookies: '_pendo_visitorId.<id>, _pendo_accountId.<id>, _pendo_meta.<id>'
    },
    {
      vendor: 'Convert',
      vendorURL: 'https://www.convert.com/privacy-notice/',
      cookies: '_conv_v'
    },
    {
      vendor: 'PostHog',
      vendorURL: 'https://posthog.com/privacy',
      cookies: '__pdst'
    },
    {
      vendor: 'Amplitude Analytics',
      vendorURL: 'https://amplitude.com/privacy',
      cookies: 'amp_adc4c4'
    },
    {
      vendor: 'Beamer',
      vendorURL: 'https://www.getbeamer.com/privacy-policy',
      cookies: '_BEAMER_BOOSTED_ANNOUNCEMENT_DATE*'
    },
    {
      vendor: 'ContentSquare',
      vendorURL: 'https://contentsquare.com/privacy-policy/',
      cookies: '_cs_id, _cs_s'
    }
  ]
};
